import { useState, useEffect } from "react";
import promoImageLg from "../assets/promoImage-lg.png";
import promoImageMobile from "../assets/promoImage-mobile.png";

export default function PromoCard({ promoRef }) {
  const [backgroundImage, setBackgroundImage] = useState(promoImageLg);
  const [imageSize, setImageSize] = useState("35rem");

  const scrollToPlans = () => {
    promoRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // Set initial values based on window width
    if (window.innerWidth < 768) { // md breakpoint
      setBackgroundImage(promoImageMobile);
      setImageSize("12rem");
    } else if (window.innerWidth < 1024) { // lg breakpoint
      setBackgroundImage(promoImageMobile);
      setImageSize("20rem");
    } else if (window.innerWidth < 1280) { // xl breakpoint
      setBackgroundImage(promoImageLg);
      setImageSize("25rem");
    } else {
      setBackgroundImage(promoImageLg);
      setImageSize("35rem");
    }
    
    // Add resize listener
    const handleResize = () => {
      if (window.innerWidth < 768) { // md breakpoint
        setBackgroundImage(promoImageMobile);
        setImageSize("12rem");
      } else if (window.innerWidth < 1024) { // lg breakpoint
        setBackgroundImage(promoImageMobile);
        setImageSize("20rem");
      } else if (window.innerWidth < 1280) { // xl breakpoint
        setBackgroundImage(promoImageLg);
        setImageSize("25rem");
      } else {
        setBackgroundImage(promoImageLg);
        setImageSize("35rem");
      }
    };

    window.addEventListener("resize", handleResize);
    
    // Clean up
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="bg-lime-100 md:bg-lime-50 bg-right-top bg-no-repeat rounded-[20px] shadow-md my-8 px-3 md:px-5 py-6 md:py-5 overflow-hidden z-50"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: imageSize,
      }}
    >
      <div className="flex flex-row items-start justify-start w-full">
      <div className="text-left space-y-2 xlspace-y-3 mr-auto w-full md:w-[50%] lg:w-[60%] xl:w-FULL">
        {/* Responsive text sizes for the heading */}
        <h2 className="text-xl md:text-2xl lg:text-[42px] xl:text-[48px] text-[#FF9900] xl:text-orange-400 font-bold leading-[20px] tracking-[0.05em] mb-1">
          SPECIAL PROMO
        </h2>
        
        {/* Responsive text sizes for the description */}
        <h4 className="text-[#18487F] text-xs md:text-base lg:text-xl xl:text-[25px] leading-[18px] font-bold w-[50%] md:w-full">
          Limited-time promotional prices!{" "}
          <span 
            className="text-[#27C4F4] cursor-pointer hover:underline transition-all duration-200"
            onClick={scrollToPlans}
          >
            Subscribe now
          </span> to lock <br className="hidden lg:inline" />
          in the deal
        </h4>
        
        {/* Responsive button */}
        <button
          className="bg-gradient-to-r from-[#0D8CF0] to-[#07A464] rounded-full xl:rounded-[2rem] cursor-pointer hover:opacity-90 xl:hover:bg-[#1ab3e6] h-[35px] xl:h-[48px] w-[120px] sm:w-[130px] md:w-[140px] xl:w-[163px] transition-all duration-300 flex items-center justify-center"
          onClick={scrollToPlans}
        >
          <span className="text-xs sm:text-sm font-semibold text-white flex items-center xl:block">
            Explore Plans
            <svg xmlns="http://www.w3.org/2000/svg" className="size-4 xl:size-5 ml-1 inline-block" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </span>
        </button>
      </div>
      </div>
    </div>
  );
}
